import { GameAssets, IconAssets } from '../../utils/enums/assets';
import { BreackpointsX } from '../../utils/enums/breackpoints';
import { Image } from '../../utils/types/gameObjects';

type IconSettings = Partial<{
  interactive: boolean;
}>;

export class UiIcons {
  static HomeIcon(context: Phaser.Scene, settings?: IconSettings): Image {
    const [x, y, scale] = UiIcons.getTopIconTransform(context, true);
    const icon = context.add.image(x, y, IconAssets.HOME_ICON).setScale(scale);
    return UiIcons.setIconProps(icon, settings);
  }

  static SoundIcon(context: Phaser.Scene, settings?: IconSettings): Image {
    const [x, y, scale] = UiIcons.getTopIconTransform(context, true);
    const isTablet = context.game.canvas.width < BreackpointsX.TABLET;
    const icon = isTablet
      ? context.add.image(x, y, IconAssets.SOUND_ICON).setOrigin(3, 1).setScale(scale)
      : context.add.image(x, y, IconAssets.SOUND_ICON).setScale(scale);

    return UiIcons.setIconProps(icon, settings);
  }

  static FullScreenIcon(context: Phaser.Scene): Image {
    const [x, y, scale] = UiIcons.getTopIconTransform(context);

    return context.add
      .image(x, y, IconAssets.SCALE_OUT_ICON)
      .setScale(scale)
      .setInteractive({ cursor: 'pointer' })
      .on('pointerdown', () => {
        if (context.game.scale.isFullscreen) {
          context.game.scale.stopFullscreen();
        } else {
          context.game.scale.startFullscreen();
        }
      });
  }

  static CoinIcon(context: Phaser.Scene): Image {
    const [x, y, scale] = UiIcons.getTopIconTransform(context);
    return context.add.image(x, y, GameAssets.COIN).setScale(0.6 * scale);
  }

  static LifeIcon(context: Phaser.Scene): Image {
    const [x, y, scale] = UiIcons.getTopIconTransform(context, true);
    if (context.game.canvas.width < BreackpointsX.TABLET) {
      return context.add.image(x + 100, y + 2, GameAssets.LIFE).setScale(0.6 * scale);
    }
    return context.add.image(x + 180, y + 3, GameAssets.LIFE).setScale(0.6 * scale, 0.5 * scale);
  }

  static setIconProps(icon: Image, settings?: IconSettings): Image {
    if (settings?.interactive) {
      return icon.setInteractive({ cursor: 'pointer' });
    }
    return icon;
  }

  static getTopIconTransform(context: Phaser.Scene, left = false): [number, number, number] {
    const width = context.game.canvas.width;
    let scale = 1;
    let x = left ? 63 : width - 63;
    let y = 47;

    if (width <= BreackpointsX.LAPTOP) {
      scale = 0.72;
      y = 45;
    }
    if (width < BreackpointsX.TABLET) {
      scale = 0.43;
      x = left ? 28 : width - 28;
      y = 35;
    }

    return [x, y, scale];
  }
}
